import React, { useContext, useEffect, useState } from 'react'
import { Button, Col, Row } from 'antd'
import { Formik } from 'formik'
import CustomSelect from '../../../components/CustomSelect/customSelect'
import { api, request } from '../../../util/handlerRequestUtil'
import { getMessage } from '../../../util/IntlMessages'
import { CustomerActionsPlanContext } from './CustomerActionsPlan'

const FilterActionPlan = () => {
  const { filters, setFilters, customerId } = useContext(CustomerActionsPlanContext)
  const [safra, setSafra] = useState([])

  useEffect(() => {
    async function fetchSafra() {
      const safras = await request(api.listSafraDropdown({ active: true, todos: false }))
      setSafra(safras)
    }

    fetchSafra()
  }, [])

  useEffect(() => {
    if (safra.length) {
      setFilters({ ...filters, idSafra: safra.at(-1).value, locations: [] })
      onChangeSafra(safra.at(-1).value)
    }
  }, [safra])

  async function onChangeSafra(field) {
    setFilters({
      ...filters,
      idSafra: field,
      locations: []
    })
  }

  async function generalActionPlanPdf() {
    await api.exportActionPlanPdfByCustomer(customerId, filters)
  }

  return (
    <Formik initialValues={{}} onSubmit={() => {}}>
      {({ errors, setFieldValue }) => {
        const setFieldValueWithState = (field, value) => {
          setFilters({ ...filters, [field]: value })
          return setFieldValue(field, value)
        }
        return (
          <>
            <Row type="flex" justifyContent="right">
              <Col span={14} />
              <CustomSelect
                showSearch
                label={getMessage('safra')}
                field="idSafra"
                errors={errors}
                setFieldValue={setFieldValueWithState}
                onChange={onChangeSafra}
                rowSpan={6}
                value={filters}
                values={safra}
                required
              />

              <Button
                icon="download"
                style={{
                  width: '15%',
                  color: '#EE778F',
                  marginTop: '24px'
                }}
                type="ghost"
                onClick={generalActionPlanPdf}
              >
                {getMessage('exportPdf')}
              </Button>
              <Col />
            </Row>
          </>
        )
      }}
    </Formik>
  )
}

export default FilterActionPlan
